import { formatDateBR } from "@/utils/dateFormat";

/**
 * "Retrato de dd/mm/aaaa · o Instagram não guarda histórico" — o subtítulo dos três cards de
 * demografia (M-011).
 *
 * O Instagram só entrega a audiência de agora: não há gênero, idade ou cidade de uma data
 * passada. Por isso os cards mostram a data do retrato (`snapshot_at`), e não o período do
 * filtro. Sem instante, avisam que é o retrato atual em vez de inventar uma data.
 */
export function demographicsSnapshotLabel(
  snapshotAt: string | null | undefined,
): string {
  const aviso = "o Instagram não guarda histórico";
  if (!snapshotAt) return `Retrato atual · ${aviso}`;
  // `new Date` e não o texto ISO: a data é a do fuso de quem vê, e não a do UTC.
  const data = formatDateBR(new Date(snapshotAt));
  return data ? `Retrato de ${data} · ${aviso}` : `Retrato atual · ${aviso}`;
}
